import * as React from 'react'
import { Alert, Button, Form, Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { BusinessForm, ContractStatus } from 'api/common/constants'
import { identificationRegisterForCompanyAPI } from 'api/identification'
import Footer from 'components/Footer'
import Header from 'components/Header'
import { reactLoop, toBase64 } from 'utilities/helper'
import loginData from 'utilities/loginData'
import { useIdentification } from 'hooks/useIdentification'
import { useIdentificationStatus } from 'hooks/useIdentificationStatus'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const { startIdentification, error, clearError } = useIdentification()
  const { contractStatus, checkLoginStatus } = useIdentificationStatus()
  const isCompany = React.useMemo(() => loginData.getUserType() === BusinessForm.Company, [])
  const [individualEnterSucceeded, setIndividualEnterSucceeded] = React.useState(false)
  const [companyEntered, setCompanyEntered] = React.useState(false)
  const [committed, setCommitted] = React.useState(false)
  const [fileRecord, setFileRecord] = React.useState<Record<number, File | undefined>>({})
  React.useEffect(() => {
    checkLoginStatus()
  }, [checkLoginStatus])
  React.useEffect(() => {
    setCompanyEntered(Object.entries(fileRecord).some(([, file]) => !!file))
  }, [fileRecord])

  const handleUploadChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    setFileRecord({ ...fileRecord, [index]: file })
  }

  /**
   * 「本人確認書類を撮影する」ボタン
   */
  const handleStartIndividualAuthButton = async () => {
    const success = await startIdentification()
    if (success) {
      setIndividualEnterSucceeded(true)
    }
  }

  /**
   * 「本人確認をはじめる」ボタン
   */
  const handleStartCompanyAuthButton = async () => {
    setCommitted(true)
    const fileList: Record<number, string> = {}
    for (const [index, file] of Object.entries(fileRecord)) {
      if (file) {
        fileList[Number(index)] = await toBase64(file)
      }
    }
    identificationRegisterForCompanyAPI(
      {
        file1: fileList[0],
        file2: fileList[1],
        file3: fileList[2],
        file4: fileList[3],
        file5: fileList[4],
        file6: fileList[5],
        file7: fileList[6],
        file8: fileList[7],
        file9: fileList[8],
        file10: fileList[9],
      },
      (result) => {
        if (result) {
          navigate('/registerIdentificationForCompanyComplete')
        } else {
          setCommitted(false)
        }
      },
    )
  }
  return (
    <>
      <Header title="証明書登録" />
      <main>
        <section className="mx-4 my-5">
          <h3 className="fw-bold">個人契約</h3>
          <div className="note">
            <div>※法人契約の方も個人の証明書登録が必要です</div>
            <div>※証明書の登録を行ってください。証明書の撮影が必要になります。</div>
            <div>※法人契約が非承認になった場合は個人の契約になります。</div>
            <div>※運転免許証の記載内容に変更のある場合は証明書登録ができません。</div>
          </div>
          <div className="note mt-3">
            <div>登録可能な証明書は以下となります。</div>
            <div>・パスポート</div>
            <div>・運転免許証</div>
            <div>・マイナンバーカード</div>
            <div>・在留カード</div>
          </div>
          <div className="mt-4">
            {isCompany && contractStatus !== null && contractStatus >= ContractStatus.PersonalDocumentRegistered && (
              <Alert variant="success" className="mb-3">
                本人確認済み
              </Alert>
            )}
            <div>
              <Button
                variant="primary"
                className="w-100 py-4"
                onClick={handleStartIndividualAuthButton}
                disabled={!(isCompany && contractStatus !== null && contractStatus === ContractStatus.ApplicationAndAgreementRegistered && !individualEnterSucceeded)}
              >
                本人確認書類を撮影する
              </Button>
            </div>
          </div>
        </section>
        <section className="mx-4 my-5">
          <h3 className="fw-bold">法人契約</h3>
          <div className="note mt-3">
            <div>登録可能な証明書は以下となります。</div>
            <div>・発行後3ヶ月以内の登記事項証明書（履歴事項全部証明書）の全ページ</div>
          </div>
          <div className="mt-5">
            {reactLoop(10).map((i) => (
              <Form.Group className="mb-3" key={i}>
                <Form.Label className="note">No. {i + 1}</Form.Label>
                <Form.Control
                  type="file"
                  className="border-color-input note"
                  size="lg"
                  accept="image/jpg,image/jpeg,image/png,image/gif"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleUploadChange(i, e)}
                />
              </Form.Group>
            ))}
            <div className="mt-5">
              <Button
                variant="primary"
                className="w-100 py-4"
                onClick={handleStartCompanyAuthButton}
                disabled={!(isCompany && contractStatus !== null && contractStatus === ContractStatus.PersonalDocumentRegistered && companyEntered && !committed)}
              >
                本人確認をはじめる
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />

      <Modal show={!!error} onHide={clearError}>
        <Modal.Body>{error?.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={clearError}>
            閉じる
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SceneComponent
